import { render, staticRenderFns } from "./STabs.vue?vue&type=template&id=07fe3125&scoped=true&"
import script from "./STabs.vue?vue&type=script&lang=js&"
export * from "./STabs.vue?vue&type=script&lang=js&"
import style0 from "./STabs.vue?vue&type=style&index=0&id=07fe3125&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fe3125",
  null
  
)

export default component.exports